export { TypeOfAttachment } from './TypeOfAttachment';
export { getTypeOfAttachment } from './getTypeOfAttachment';
